require("./notificationManagementView.scss");

// @ vendor
const React = require("react");
const { connect } = require("react-redux");
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const { OKCover } = require("commonsComponents/OKCover");
const OKHeaderLanding = require("components/commons/OKHeaderLanding/OKHeaderLanding");

const { CallMeBack } = require("components/callMeBack/callMeBack");
// import { NotificationSettingView }  from 'ok-notification-management'
const { NotificationSettingView } = require('ok-notification-management');
const { initNotificationManagement } = require('ok-notification-management');

const ContactInfoBox = require("components/myProfile/contactInfoBox/contactInfoBox");

const infoIcon = require("assets/images/icon-info-blue.svg");

let environmentConfig = require('core/environmentConfig');

class NotificationManagementView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            default: null
        };
    }

    render() {
        return (
            <div>
                <div className="container-fluid user-notifications--header-identifier">
                    <div className="row">
                        <OKCover
                            size="small"
                            section="pg"
                            customClass="col-xs-12"
                        >
                            <OKHeaderLanding title={formatText('notificationManagement-titleCover')} />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid grid-view--content-position-positive">
                        <div className="row">
                            <div className="col-xs-12 col-md-8">
                                <NotificationSettingView
                                    formatText={(id) => <FormattedText value={id} />}
                                    configuration={initNotificationManagement(environmentConfig.baseHost)}
                                />
                            </div>
                            <div className="col-xs-12 col-md-4">
                                <div className="row">
                                    <div className="col-xs-6 col-md-12">
                                        <ContactInfoBox
                                            boxTitle={formatText('notificationManagement-titleInfoBox')}
                                            boxBody={formatText('notificationManagement-bodyInfoBox')}
                                            icon={infoIcon}
                                        />
                                    </div>
                                    <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                                        <CallMeBack isSmall={true} pageTitle={formatText('notificationManagement-titleCover')} hasEntrance={false} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

NotificationManagementView.propTypes = {};

module.exports.constructor = NotificationManagementView;
module.exports.NotificationManagementView = connect(() => ({}),{})(NotificationManagementView);
